<script setup>
import { defineEmits, defineProps } from 'vue';

const props = defineProps({
  column: {
    type: String,
    required: true,
  },
  sortColumn: {
    type: String,
    required: true,
  },
  sortDirection: {
    type: String,
    required: true,
  },
  minWidth: {
    type: String,
    required: true,
  }
});

const emit = defineEmits(['sort']);

const emitSort = () => {
  emit('sort', props.column);
};
</script>

<template>
  <div
    :style="{ minWidth: minWidth + 'rem' }"
    :class="[
      'cursor-pointer bg-metal-800 text-metal-300 border-b border-t pt-2.5 flex-1',
      sortColumn !== column ? 'border-b-metal-800 border-t-metal-800' : '',
      sortColumn === column && sortDirection === 'asc' ? 'border-b-metal-400 border-t-metal-800' : '',
      sortColumn === column && sortDirection === 'desc' ? 'border-t-metal-400 border-b-metal-800' : ''
    ]"
    @click="emitSort"
  >
    <slot></slot>
  </div>
</template>
